import type { BaseViews } from "../../../types/react";
import type { TooltipAlignment, TooltipSide, TooltipViews } from "../types";

export const DEFAULT_VIEW: BaseViews | TooltipViews = "accent-blue";
export const DEFAULT_SIDE: TooltipSide = "top";
export const DEFAULT_ALIGNMENT: TooltipAlignment = "center";
export const DEFAULT_ADJUSTMENT_LOCKED: boolean = false;
export const TOOLTIP_ROLE: React.AriaRole = "tooltip";
export const TOOLTIP_ARIA_LIVE: React.AriaAttributes["aria-live"] = "polite";
export const TOOLTIP_TEST_ID: string = "tooltip-test-id";
